import {
  FunctionDto,
  ProjectSizeCategoryDto,
  IndustryDto,
  SpecialityDto,
  UserDto,
  BusinessLineDto
} from '../services/generated';
import { AcknowledgementsProcessDto } from '../services/generated/models/AcknowledgementsProcessDto';

export class AcknowledgementsProcess implements AcknowledgementsProcessDto {
  public id: number;
  public url: string = '';
  public unitId: number;
  public title: string | null;
  public functionString: string = '';
  public processOwner: UserDto | null;
  public secondaryProcessOwners: UserDto[] | null;
  public function: FunctionDto | null;
  public checkedAcknowledgementItem?: boolean = false;
  public projectSizeCategories: ProjectSizeCategoryDto[] | null;
  public industries: IndustryDto[] | null;
  public specialities: SpecialityDto[] | null;
  public nextUpdate: string;
  public businessLines: BusinessLineDto[] | null;


  constructor(process: AcknowledgementsProcessDto) {
    this.id = process.id;
    this.processOwner = process.processOwner;
    this.secondaryProcessOwners = process.secondaryProcessOwners;
    this.function = process.function;
    this.projectSizeCategories = process.projectSizeCategories;
    this.industries = process.industries;
    this.specialities = process.specialities;
    this.nextUpdate = process.nextUpdate;
    this.businessLines = process.businessLines;
    this.title = process.title;
    this.unitId = process.unitId;

  

    Object.defineProperty(this, 'url', {
      get() {
        return `/unit/${this.unitId}/process/${this.id}`;
      }
    });

    Object.defineProperty(this, 'functionString', {
      get() {
        return process.function?.value || '';
      }
    });
  }
}
